
import { userRoles } from "../components/Utility/userRoles"

const permissionDetails = userRoles().findUserAllPermission()
const loginDetails = sessionStorage.getItem("userDetails")
const loggedInUserDetails = loginDetails
    ? JSON.parse(loginDetails)?.languages
    : null

const activityUrls = {
    1: "/salesOrg",
    2: "/actionCode",
    5: "/FailureCode",
    7: "/failure-code-mapped-type-number",
    8: "/exceptionsCode",
    10: "/productFrom",
    13: "/hubContinents",
    14: "/exceptionApprovers",
    16: "/hubSubContinents",
    17: "/servicecenternetwork/hubCountry",
    19: "/global/orderMinMaxQty",
    26: "/countryconfiguration",
    31: "/priceList",
    32: "/exchangerate",
    33: "/priceMatrix",
    35: "/listPriceUpload",
    65: "/warrantytype",
    67: "/shippingmethod",
    72: "/rolespermission",
    73: "/manageuser",
    78: "/hubRegionalContinents",
    85: "/priceMatrixException",
    102: "/priceDerivation",
    102: "/lumsumPrice",
    126: "/allowedMaterials",
    143: "/typeOfRepair",
    144: "/reasonForImpossibility",
    145: "/pay-for-performance"
}

function getWritePermissionUrl(activityIds) {
    for (let activityId of activityIds) {
        const permission = permissionDetails?.find(
            (detail) => detail.activity_id === activityId
        )
        if (permission && permission?._read) {
            return activityUrls[activityId] || "/actionCode"
        }
    }
    return "/actionCode" // Fallback if no write permission is found
}

// Warranty Activity ID
const activityId = 119 // DON'T MODIFY ACTIVITY ID UNLESS UNTIL ANY CHANGES DONE FROM API
const warrantySubMenuPermission = userRoles().findUserRolesForPage(activityId)

// Warranty Performa Invoice Activity ID
const peractivityId = 121 // DON'T MODIFY ACTIVITY ID UNLESS UNTIL ANY CHANGES DONE FROM API
const performaInvoice = userRoles().findUserRolesForPage(peractivityId)

// Device Registration Activity ID
const deviceRegistrationActivityId = 151 // DON'T MODIFY ACTIVITY ID UNLESS UNTIL ANY CHANGES DONE FROM API
const deviceRegistrationSubMenuPermission = userRoles().findUserRolesForPage(deviceRegistrationActivityId)

export const navMenu = (user_type, logedInSecondary) => [
    {
        activity_id:[ 119, 121, 151],
        name: "warranty",
        url: "#", 
        // 1 => user_type , FOR EXTERNAL(SERVICE CENTER), 2=> FOR INTERNAL (P&G)
        subMenu: [
            ...(user_type === 1 ? [
                ...(warrantySubMenuPermission?._write ? [ {
                    activity_id: 119,
                    name: "newTicket",
                    url: "/warranty/new-ticket"
                } ] : []),

                ...(warrantySubMenuPermission?._read ? [  {
                    activity_id: 119,
                    name: "ticketList",
                    url: "/warranty/ticket-list"
                } ] : []),
               
                {
                    activity_id: 119,
                    name: "ticketUpload",
                    url: "/warranty/ticket-upload"
                },
                ...(!logedInSecondary && performaInvoice?._read ? [  {
                    activity_id: 121,
                    name: "proformaInvoice",
                    url: "/warranty/proforma-invoice"
                } ] : []),
                {
                    activity_id: 119,
                    name: "sampleCollection",
                    url: "/warranty/sample-collection"
                },
                {
                    activity_id: 119,
                    name: "aarOverview",
                    url: "/warranty/aar-overview"
                }
            ] : []),
            ...(user_type === 2 ? [{
                activity_id: 121,
                name: "warrantyManagement",
                url: "/warranty/warranty-management"
            },
            {
                activity_id: 131,
                name: "autoApprovalRules",
                url: "/warranty/auto-approval-rules"
            },] : []),
           
            ...(deviceRegistrationSubMenuPermission?._read ? [  {
                activity_id: 151,
                name: "deviceRegistration",
                url: "/warranty/device-registration"
            } ] : []),

        ] 
    },
    {
        activity_id: [52,53,54,94,93,103,92,91,96,97,95,103,104,105,106,107,108,119,120,131],
        name: "productParts",
        url: "#",
        subMenu: [
            ...(user_type === 2 ? [  {
                activity_id: 52,
                name: "productManagement",
                url: "/product-management/type-number"
            } ] : []),
            {
                activity_id: 97,
                name: "productCatalogue",
                url: "/productcatalogue"
            },
            {
                activity_id: 25,
                name: "order",
                url: "/order"   
            },
            ...(user_type === 2 ? [  {
                activity_id: 29,
                name: "inventoryStatus",
                url: "/inventoryStatus"
            } ] : [])
        ]  
    },
    {
        activity_id: 39,
        name: "newsandbulletin",
        url: "/newsandbulletin"
    },
    
    {
        activity_id: 44,
        name: "training",
        url: "/training"
    },
    {
        activity_id: [61,62,63,64],
        name: "Report",
        subMenu: [
            ...user_type === 2 ? [{
                activity_id: 62,
                name: "staticReport",
                url: "/staticReport"
            },
            {
                activity_id: 62, // CHANGE THIS ACTIVITY ID ONCE CREATED
                name: "NOSMaterialsReport",
                url: "/nos-and-materials-report"
            }] : [],
            {
                activity_id: 64,
                name: "serviceCenterFactSheet",
                url: "/serviceCenterFactSheet"
            },
            {
                activity_id: 63,
                name: "performancereport",
                url: "/PFPReport/pay-for-performance-report"
            }
        ],
        url: "#"
    },
    {
        activity_id: 70,
        name: "serviceNetwork",
        url: "/service-network"
    },
    ...(user_type === 2 ? [  {
        activity_id: 71,
        name: "myApprovals",
        url: "/myApprovals"
    } ] : []),
   
    ...(user_type === 2 ? [  {
        activity_id: [
            1, 32, 16, 17, 13, 10, 14, 8, 7, 5, 65, 67, 2, 73, 74, 75, 76, 19, 31, 145 
        ],
        name: "admin",
        subMenu: [
            {
                activity_id: [2, 67, 65, 5, 7, 8, 14, 10, 13, 17, 16, 32, 1, 31, 33, 85, 102, 19 ],
                name: "masterData",
                url: ""
            },
            {
                activity_id: [73,74,72,75,76],
                name: "userManagement",
                url: ""
            },
            {
                activity_id: [150],
                name: "payForPerformance",
                url: "/pay-for-performance"
            }
        ],
        url: "#"
    } ] : []),
   
    {
        activity_id: 69,
        name: "help",
        subMenu: [
            {
                activity_id: 42,
                name: "regulatorydocuments",
                url: "/regulatory-document"
            },
            {
                activity_id: 69,
                name: "generalExtraInstruction",
                url: "/general-extra-instruction"
            }
        ],
        url: "#"
    }
]

// Function to dynamically change the URL for the specific menu item
export function updateSpecificUrlPath(navMenu) {
    navMenu?.forEach((menuItem) => {       
        if (menuItem.name === "masterData" || menuItem.name === "userManagement") {
            // Target the specific menu item
            const redirectUrl = getWritePermissionUrl(menuItem.activity_id)
            menuItem.url = redirectUrl
        }
        if (menuItem.subMenu) {
            updateSpecificUrlPath(menuItem.subMenu) // Continue recursively if there are submenus
        }
    })
}

export const accordionType = "modules"

export const PAGINATION = {
    pageIndex: 1,
    pageSize: 10
}

export const PAGINATION_FOR_TRAINING = {
    pageIndex: 1,
    pageSize: 12
}

export const LAST_DATE_BYDEFAULT = new Date("12/31/2099")

export const IMAGE_FORMAT = ["jpeg", "jpg", "JPEG", "JPG", "png", "PNG", "gif", "GIF"]

export const IMAGE_NOT_AVAILABLE = `${process.env.PUBLIC_URL}/assets/images/image-not-available.jpg`

export const HTML_ENTITIES = [
    ["amp", "&"],
    ["apos", "'"],
    ["#x27", "'"],
    ["#x2F", "/"],
    ["#39", "'"],
    ["#47", "/"],
    ["lt", "<"],
    ["gt", ">"],
    ["nbsp", " "],
    ["quot", "\""]
]

export const newsSortByOptions = [
    { label: "All", value: "all" },
    { label: "Local News", value: "local" },
    { label: "Global News", value: "global" }
]

export const bulletinSortByOptions = [
    { label: "All", value: "all" },
    { label: "OC", value: "OC" },
    { label: "SH", value: "SH" },
    { label: "HH", value: "HH" }
]

export const emailValidationRegX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g

export const lengthOptions = {
    "EAN Code": 13,
    "Part Number": 8,
    "Max value": 6,
    "finishedGoodNo" : 8
}

export const numberRegex = /^\d+$/

export const decimalRegExNew = /^(\d{1,6})+(\.\d{0,2})?$/

export const greaterThanOneReg= /^(?:[1-9]|\d\d\d*)$/

export const numberwWthCommaRegEx = /^[0-9.,]*$/

export const isValidEmailRegx =  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export const pageOptions = [
    {
        label: "10",
        value: "10"
    },
    {
        label: "20",
        value: "20"
    },
    {
        label: "50",
        value: "50"
    },
    {
        label: "100",
        value: "100"
    },
    {
        label: "200",
        value: "200"
    }
]

export const pageOptions12Grid = [
    {
        label: "12",
        value: "12"
    },
    {
        label: "24",
        value: "24"
    },
    {
        label: "48",
        value: "48"
    },
    {
        label: "96",
        value: "96"
    },
    {
        label: "192",
        value: "192"
    }
]

export const pageOptions9Grid = [
    {
        label: "9",
        value: "9"
    },
    {
        label: "18",
        value: "18"
    },
    {
        label: "36",
        value: "36"
    },
    {
        label: "72",
        value: "72"
    },
    {
        label: "144",
        value: "144"
    }
]

export const REGEX_PATTERN ={
    EMAIL :/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+.[a-zA-Z]{2,63}(?:.[a-zA-Z]{2,63})?$/,
    FAX : /^[- + (0-9)]{9,20}$/,
    URL : /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi
}

export const LOCATION_HOST = window?.location?.host?.split(".")[0]

export const viewOptions = [
    {
        label: "Last 10 days",
        value: "10"
    },
    {
        label: "Last 30 days",
        value: "30"
    },
    {
        label: "Last 60 days",
        value: "60"
    },
    {
        label: "Last 90 days",
        value: "90"
    }
]

export const statusOptions = [
    {
        label: "Pending",
        value: "Pending"
    },
    {
        label: "Approved",
        value: "Approved"
    },
    {
        label: "Rejected",
        value: "Rejected"
    }
]

export const sapBoxIdsList = [
    {
        label:"F6P",
        value : 1

    },
    {
        label:"N6P",
        value : 2

    },
    {
        label:"A6P",
        value : 3

    },
    {
        label:"ANP",
        value : 4

    },
    {
        label:"H1P",
        value : 5

    }
]

export const ticketCategoryOptions = [
    {
        label: "Warranty Ticket",
        value: "WarantyTicketBulkUpload"      
    },
    {
        label: "Bulk inspection",
        value: "WarantyTicketBulkInspction"      
    }
]
// Get Language ID from local Storage

const filterLanguage = loggedInUserDetails && loggedInUserDetails?.find((record)=> record.is_default
)
export const defaultLanguageId = filterLanguage?.id || 12

export const COMMON_CONST = {
    yes: "Yes"
}

export const mdy_dateFormat = "MDY(Month,Day,Year)".toLocaleLowerCase()
export const dmy_dateFormat = "DMY(Day,Month,Year)".toLocaleLowerCase()
export const ymd_dateFormat = "YMD(Year,Month,Day)".toLocaleLowerCase()
export const jul_dateFormat = "JUL(YY/DDD)".toLocaleLowerCase()
export const iso_dateFormat = "ISO(YYYY-MM-DD)".toLocaleLowerCase()
export const usa_dateFormat = "USA(MM/DD/YYYY)".toLocaleLowerCase()
export const eur_dateFormat = "EUR(DD.MM.YYYY)".toLocaleLowerCase()

export const activeInactiveOption = [
    {
        label: "Active",
        value: "1"
    },
    {
        label: "Inactive",
        value: "0"
    }
]

export const failureCodeType = [
    {
        label: "Consumer code (B)",
        value: "Consumer code (B)"
    },
    {
        label: "Trouble code (F)",
        value: "Trouble code (F)"
    }
]

export const internalUserPages = [
    "/product-management/type-number",
    "/myApprovals",
    "/rolespermission",
    "/exchangerate",
    "/priceList",
    "/priceMatrix",
    "/priceMatrixException",
    "/priceDerivation",
    "/lumsumPrice",
    "/listPriceUpload",
    "/global/orderMinMaxQty",
    "/allowedMaterials",
    "/typeOfRepair",
    "/reasonForImpossibility",
    "/hubContinents",
    "/hubRegionalContinents",
    "/hubSubContinents",
    "/servicecenternetwork/hubCountry",
    "/countryconfiguration",
    "/salesOrg",
    "/actionCode",
    "/shippingmethod",
    "/warrantytype",
    "/FailureCode",
    "/failure-code-mapped-type-number",
    "/exceptionsCode",
    "/exceptionApprovers",
    "/productFrom",
    "/manageuser",
    "/staticReport"
]
// CALL THIS METHOD ONLY IF WE DON'T HAVE ACTIVITY ID
export const permission = {
    _update: true,
    _read: true,
    _write: true
}
